export const CHANNEL = {
    WEB: 'KHU',
    CC: 'KHN',
    OFFICE: 'KHO',
};

export const ORIGIN_BY_CHANNEL = {
    [CHANNEL.WEB]: 'web',
    [CHANNEL.CC]: 'contactCenter',
    [CHANNEL.OFFICE]: 'office',
};
